export interface User {
  isLogin: boolean;

  date_joined: Date;
  email: string;
  first_name: string;
  groups: string[];
  id: string;
  is_active: boolean;
  is_staff: boolean;
  is_superuser: boolean;
  last_login: Date;
  last_name: string;
  user_permissions: string[];
  username: string;
  has_subscribed_to_newsletter: boolean;
  has_verified_email: boolean;
  has_accepted_termsAndConditions: boolean;
  is_steam_account_linked: boolean;
  is_discord_account_linked: boolean;
  is_twitch_account_linked: boolean;
  has_password: boolean;
  icon_index: number;
}

export const DefaultUser: User = {
  isLogin: false,
  date_joined: new Date(),
  email: "anonymous@soulcast.online",
  first_name: "John",
  groups: [],
  id: "",
  is_active: true,
  is_staff: false,
  is_superuser: false,
  last_login: new Date(),
  last_name: "Doe",
  user_permissions: [],
  username: "Anonymous",
  has_subscribed_to_newsletter: true,
  has_verified_email: false,
  has_accepted_termsAndConditions: false,
  is_steam_account_linked: false,
  is_discord_account_linked: false,
  is_twitch_account_linked: false,
  has_password: false,
  icon_index: 2
}
